import {
  useAddToCartToast as baseUseAddToCartToast,
  useToast as baseUseToast,
  MutationType as baseMutationType,
} from "./hooks/useToast";
import { AddItemsToCartButton as baseAddItemsToCartButton } from "./components/cart/AddItemsToCartButton";
import { AddToCartButton as baseAddToCartButton } from "./components/cart/AddToCartButton";
export type { AddItemsToCartMutation } from "@cart-app/generated/graphql";

export const useAddToCartToast = baseUseAddToCartToast;
export const AddItemsToCartButton = baseAddItemsToCartButton;
export const AddToCartButton = baseAddToCartButton;
export const useToast = baseUseToast;
export const MutationType = baseMutationType;
export * from "./mocks/handlers";
